export default "__VITE_ASSET__QcyyDMtZ__"